/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} EnglishInputs */



/**
* | output |
* | --- |
* | "English" |
*
* @param {EnglishInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const english = /** @type {((inputs?: EnglishInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<EnglishInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("English")
	if (locale === "de") return /** @type {LocalizedString} */ ("Englisch")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inglese")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Английский")
	if (locale === "es") return /** @type {LocalizedString} */ ("Inglés")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("英语")
	if (locale === "ja") return /** @type {LocalizedString} */ ("英語")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अंग्रेज़ी")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Inglês")
	return /** @type {LocalizedString} */ ("English")
});